import React from 'react'
import 'antd/lib/skeleton/style/css'
import { Skeleton } from 'antd'

export const LazyLoad = ({ size = 6 }) => {
  return (
    <div
      style={{
        flexDirection: 'row',
        rowGap: '15px',
        display: 'flex',
        width: '100%',
        maxWidth: '750px',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
      }}
    >
      {Array(size)
        .fill('')
        .map((item, idx) => {
          return (
            <div style={{ width: '32%', minWidth: '32%', maxWidth: '32%' }}>
              <Skeleton.Button
                key={idx}
                active={true}
                size="default"
                shape="square"
                style={{ minWidth: '100%' }}
              />
            </div>
          )
        })}
    </div>
  )
}
